if (document.body.classList.contains('template-cart')) {
  console.log('🎉 Cart Scripts');
}
